<template>
  <v-alert
    color="primary"
    dark
    class="service-worker--alert"
    :value="updateExists"
    width="500"
  >
    <v-row align="center">
      <v-col class="grow">
        {{message}}
      </v-col>
      <v-col class="shrink">
        <v-btn color="blue darken-4" @click="refreshApp">Update</v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import swUpdate from "../../mixins/swUpdate";

export default {
  name: "App",
  data: () => ({
   message: 'An update is available. please refresh',
  }),
  mixins: [swUpdate],
};
</script>

<style scoped>
.service-worker--alert {
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, -5%);
}
</style>
